import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Page } from '../Layout/Page/Page';
import { ResendQRCodeForm } from '../SaveSession/ResendQRCode';

/**
 * Allows the user to receive another email/text of their QR code for the outdoor kiosk pickup
 */
export const OutdoorPickup: React.FC = React.memo(() => {
    const navigate = useNavigate();

    return (
        <Page>
            <ResendQRCodeForm onProceed={() => navigate(-1)} />
        </Page>
    );
});